import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year3/Summer/Time/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Time',
  field: 'Measurement',
  weeks: [5, 7],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/Time/1RomanNumeralsTo12" */ './1RomanNumeralsTo12'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/Time/2TellTheTimeTo5Minutes" */ './2TellTheTimeTo5Minutes'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/Time/3TellTheTimeToTheMinute" */ './3TellTheTimeToTheMinute'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/Time/4ReadTimeOnADigitalClock" */ './4ReadTimeOnADigitalClock'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () => import(/* webpackChunkName: "Year3/Summer/Time/5UseAMAndPM" */ './5UseAMAndPM')
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/Time/6YearsMonthsAndDays" */ './6YearsMonthsAndDays'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(/* webpackChunkName: "Year3/Summer/Time/7DaysAndHours" */ './7DaysAndHours')
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/Time/8HoursAndMinutesUseStartAndEndTimes" */ './8HoursAndMinutesUseStartAndEndTimes'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/Time/9HoursAndMinutesUseDurations" */ './9HoursAndMinutesUseDurations'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/Time/10MinutesAndSeconds" */ './10MinutesAndSeconds'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(/* webpackChunkName: "Year3/Summer/Time/11UnitsOfTime" */ './11UnitsOfTime')
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/Time/12SolveProblemsWithTime" */ './12SolveProblemsWithTime'
        )
    })
  ]
});
export default Block;
